<template>
  <div id="app">
    <router-link class="btn btn-danger" to="/logout" style="position:absolute;top:5px;right:5px">
        Logout
    </router-link>
    <div>
      <router-link to="/">
        <img alt="Vue logo" src="./assets/logo.jpg">
      </router-link>
    </div>
    <div class="container">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: 'Roboto Mono', monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>